<iframe
  src="/assets/Tarang-meme-battle/index.html"
  width="100%"
  height="100%"
  frameborder="0"
  scrolling="auto"
  style="display:block; border:none; width:100%; height:100vh;">
</iframe>